import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  fieldContainer: {
    position: 'relative',
    '& > div:last-child': {
      width: '100%',
    },
  },
  unitView: {
    pointerEvents: 'none',
    position: 'absolute',
    fontSize: '10px',
    bottom: '4px',
  },
  programValue: {
    color: theme.palette.text.disabled,
  },
  fakeInput: {
    height: 0,
    maxHeight: 0,
    position: 'absolute',
    visibility: 'hidden',
    whiteSpace: 'pre',
    fontSize: '14px',
    maxWidth: 'calc(100% - 40px)',
  },
  viewModeField: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    // marginLeft: '6px',
  },
}));
